import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditProductDiscount = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit Product Discount'
      fields={fields}
      apiPath={`admin/product_discounts/${props.params.productDiscountId}`}
      successRedirectPath='/ecommerce/product-discounts'
      buildMenuItems={menuItems}
    />
  )
}

export default EditProductDiscount
